import { CONFIG } from "../../appConfig";
import { get } from "../../utils/js/object";
import { types } from "../../utils/js/types";
import STATE from "../../constants/state";
const REWARDS = "rewards/";

export default {
  /**
   * @desc Retrieve Points History
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.rewards
   * @example
   * const params = {
   *   startDate, // *(String)*
   *   endDate, // *(String)*
   *   pageNumber // *(Number)*
   *   activitiesPerPage // *(Number)*
   * }
   * services.gma.rewards.history({params});
   */
  history(data = {}) {
    const { params = {} } = data;
    if (!types(get(params, "activitiesPerPage")).isDefined) {
      params.activitiesPerPage = 5;
    }
    return {
      method: "GET",
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${REWARDS}history`,
      params
    };
  },

  /**
   * @desc Claim missing rental activity
   * @param {Object} data {payload}
   * @returns {Object}
   * @memberof services.gma.rewards
   * @example
   * const payload = {
   *  loyalty_id: '123898123',
   *  brand_id: 'NL',
   *  pickup_location_free_form: 'St. Louis Lambert International Airport',
   *  pickup_date: '20191026',
   *  return_date: '20191027',
   *  ticket_number: '12345',
   *  confirmation_number: '68790'
   * }
   * // if calling service directly...
   * services.gma.rewards.retroClaim({payload});
   * // if dispatching via actions.request to save resp in store...
   * dispatch(actions.request({service:services.gma.rewards.retroClaim, data:{payload}});
   * // dispatched results stored in `state.gmi.gma.rewards.retro_claim`
   */
  retroClaim(data = {}) {
    const { payload = {}, params = {} } = data;
    return {
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${REWARDS}retroClaim`,
      data: payload,
      params,
      statePath: STATE.GMA.REWARDS.RETRO_CLAIM
    };
  },

  /**
   * @desc Transfer points to another loyalty customer
   * @param {Object} data {payload}
   * @returns {Object}
   * @memberof services.gma.rewards
   * @example
   * const payload = {
   *  points_to_transfer: '500',
   *  recipient_last_name: 'Toaster',
   *  recipient_loyalty_number: '12345',
   *  recipient_message: 'A small gift from me to you',
   *  source_alternate_email: 'test@ehi.com'
   * }
   * // if calling service directly...
   * services.gma.rewards.transferPoints({payload});
   * // if dispatching via actions.request to save resp in store...
   * dispatch(actions.request({service:services.gma.rewards.transferPoints, data:{payload}});
   * // dispatched results stored in `state.gmi.gma.rewards.transfer_points`
   */
  transferPoints(data = {}) {
    const { payload = {}, params = {} } = data;
    return {
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${REWARDS}transferPoints`,
      data: payload,
      params,
      statePath: STATE.GMA.REWARDS.TRANSFER_POINTS
    };
  },

  /**
   * @desc Request missing points
   * @param {Object} data {payload}
   * @returns {Object}
   * @memberof services.gma.rewards
   * @example
   * const payload = {
   *  confirmation_number: '1207386922',
   *  pickup_location_name: 'Chicago O'\''Hare International Airport',
   *  pickup_date: '2023-04-19',
   *  return_date: '2023-04-20',
   *  pickup_peoplesoft_id: '1019129',
   *  return_peoplesoft_id: '1019129'
   * }
   * services.gma.rewards.retroRewardsClaim(payload);
   */
  retroRewardsClaim(data = {}) {
    const { payload = {}, params = {} } = data;
    return {
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${REWARDS}retroRewardsClaim`,
      data: payload,
      params
    };
  },

  /**
   * @desc Transaction history
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.rewards
   * @example
   * const params = {
   *  startDate: '2021-06-13',
   *  endDate: '2023-06-13'
   * }
   * services.gma.rewards.transactionHistory({params});
   */
  transactionHistory(data = {}) {
    const { params = {} } = data;
    return {
      method: "GET",
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${REWARDS}transactionHistory`,
      params,
      statePath: STATE.GMA.REWARDS.TRANSACTION_HISTORY
    };
  },

  /**
   * @desc Redeposit points
   * @param {Object} data {payload}
   * @returns {Object}
   * @memberof services.gma.rewards
   * @example
   * const payload = {
   *  confirmation_number: '1207386922',
   *  return_date: '2023-04-20',
   *  pickup_date: '2023-04-19',
   *  pickup_peoplesoft_id: '1019129',
   *  return_peoplesoft_id: '1019129'
   * }
   * services.gma.rewards.redeposit(payload);
   */
  redeposit(data = {}) {
    const { payload = {}, params = {} } = data;
    return {
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${REWARDS}redeposit`,
      data: payload,
      params
    };
  }
};
